import { extractRouteMenuItem } from '~/stores/layout/navigation'
import { isNotUndefined } from '~/utils/lib/core/prelude'
import { MENU_ITEM } from '~/utils/lib/layout/types'
import { SIDEBAR_VIEW, useStore_layout_navigation_sidebar } from '~/stores/layout/navigation/sidebar'

/** Explicit map: every `MENU_ITEM` must have an entry. */
/** @type {Record<import('~/utils/lib/layout/types').MENU_ITEM, import('~/stores/layout/navigation/sidebar').SIDEBAR_VIEW>} */
const MENU_ITEM_TO_SIDEBAR_VIEW = {
  [MENU_ITEM.DASHBOARD]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.EMBAUCHE]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.ABSENCES]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.DOCUMENTS]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.EMPLOYEURS]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.ACTIONS_REQUISES]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.SATD]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.PAIES]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.SALARIES]: SIDEBAR_VIEW.SERVICE,
  [MENU_ITEM.PARAMETERS_GENERAL]: SIDEBAR_VIEW.PARAMETERS,
  [MENU_ITEM.PARAMETERS_USER_MANAGEMENT]: SIDEBAR_VIEW.PARAMETERS,
  [MENU_ITEM.PARAMETERS_BILLING]: SIDEBAR_VIEW.PARAMETERS,
  [MENU_ITEM.PARAMETERS_ACHATS]: SIDEBAR_VIEW.PARAMETERS,
  [MENU_ITEM.PARAMETERS_SIGNATURES]: SIDEBAR_VIEW.PARAMETERS,
}

/**
 * @param {import('~/utils/lib/layout/types').MENU_ITEM} item
 * @returns {import('~/stores/layout/navigation/sidebar').SIDEBAR_VIEW}
 */
function menuItemToSidebarView(item) {
  return MENU_ITEM_TO_SIDEBAR_VIEW[item]
}

/**
 * Syncs sidebar selection from `definePageMeta.menuItem`.
 * When `menuItem` is missing on the route, the store keeps its previous values.
 */
export default defineNuxtRouteMiddleware((to) => {
  const sidebarStore = useStore_layout_navigation_sidebar()

  const menuItem = extractRouteMenuItem(to)
  if (isNotUndefined(menuItem)) {
    // @ts-ignore: UNSAFE coerce
    sidebarStore.setMenuItem(menuItem)
    // @ts-ignore: UNSAFE coerce
    sidebarStore.setSidebarView(menuItemToSidebarView(menuItem))
  }
})
